 
  export function  numberChinese(number) {
    const strNumber = number.toString();
    const len = strNumber.length;
    let numberCh = "";
    for (let i = 0; i < len; i++) {
    //   let currentNum = strNumber.substr(i, 1);
      switch (strNumber) {
        case "0":
          numberCh = "A";
          break;
        case "1":
          numberCh = "B";
          break;
        case "2":
          numberCh = "C";
          break;
        case "3":
          numberCh = "D";
          break;
        case "4":
          numberCh = "E";
          break;
        case "5":
          numberCh = "F";
          break;
        case "6":
          numberCh = "G";
          break;
        case "7":
          numberCh = "H";
          break;
        case "8":
          numberCh = "I";
          break;
        case "9":
          numberCh = "J";
          break;
        case "10":
          numberCh = "K";
          break;
        case "11":
          numberCh = "L";
          break;
        case "12":
          numberCh = "M";
          break;
        case "13":
          numberCh = "N";
          break;
        case "14":
          numberCh = "O";
          break;
        case "15":
          numberCh = "P";
          break;
        case "16":
          numberCh = "Q";
          break;
        case "17":
          numberCh = "R";
          break;
        case "18":
          numberCh = "S";
          break;
        case "19":
          numberCh = "U";
          break;
        case "20":
          numberCh = "V";
          break
        case "21":
          numberCh = "W";
          break;
        case "22":
          numberCh = "X";
          break;
        case "23":
          numberCh = "Y";
          break;
        case "24":
          numberCh = "Z";
          break;
        default:
          numberCh = "*";
      }
    }
    return numberCh;
  }

